import { Immutable } from "immer";
import React from "react";
import { Link } from "tsi-common-react/src/components/Link/index";
import { format } from "tsi-common-react/src/utils/format";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import styles from "./index.module.scss";

type OrderOfferProps = Immutable<{
    offer_freq: string;
    benefit_value: string;
    desktop_image: string;
    mobile_image: string;
    offer_name: string;
}>;

export const OrderOffer = (props: OrderOfferProps): React.ReactNode => {
    const cardURL = usePageURL("how_will_i_receive_my_card");
    return (
        <div className={styles.grid}>
            <picture className={styles.image}>
                {/* Breakpoint must match $small from tsi-common-react defaults */}
                <source
                    media="(max-width: 500px)"
                    srcSet={props.mobile_image}
                />
                <img
                    alt={props.offer_name}
                    src={props.desktop_image}
                    loading="lazy"
                    decoding="async"
                />
            </picture>
            <div className={styles.offerInfo}>
                {/* TODO(i18n): offer_name comes from oscarbluelight.ConditionalOffer.name (plain CharField, admin-set single value, not locale-aware). */}
                <h5>{props.offer_name}</h5>
                <span>{t`Qty: ${props.offer_freq}`}</span>
                <span className={styles.offerValue}>
                    {format.money(props.benefit_value)}
                </span>
                <Link href={cardURL} target="_top">
                    {t`How will I receive my card?`}
                </Link>
            </div>
        </div>
    );
};
